import React from "react";
import { connect } from "react-redux";

// HOC for applying styles to class component
import { withStyles } from "@material-ui/core/styles";

import SimpleMapRegion from "./SimpleMapRegion";

const styles = {
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "1 0 0",
    height: "100%", //"480px",
    maxHeight: "500px",
    padding: "20px",
    position: "relative",
    overflow: "hidden",
  },
  image: {
    objectFit: "contain",
    maxHeight: "100%",
    maxWidth: "100%",
  },
  locationsContainer: {
    position: "absolute",
  },
};

// Needs to be a class component to have access to lifecycle methods and refs
class SimpleBodyMap extends React.PureComponent {
  constructor(props) {
    super(props);
    this.imageRef = React.createRef();
    // this.canvasRef = React.createRef();
    this.locationsContainer = React.createRef();
    this.state = {
      imgHeight: 500, // height of bodyMap image
      imgWidth: 500, // width of bodyMap image
    };
  }

  measureImage = () => {
    const height = this.imageRef.current.offsetHeight;
    const width = this.imageRef.current.offsetWidth;
    // only update state if theres a change
    if (height !== this.state.imgHeight || width !== this.state.imgWidth) {
      this.setState({
        ...this.state,
        imgHeight: height,
        imgWidth: width,
      });
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.measureImage);
    setTimeout(() => {
      this.measureImage();
    }, 100);
  }

  componentDidUpdate(prevProps) {
    if (this.state.imgHeight === 0) {
      this.measureImage();
    }
    if (prevProps.currentMapId !== this.props.currentMapId) {
      setTimeout(() => {
        this.measureImage();
      }, 300);
    }
  }

  componentWillUnmount() {
    // remove event listener when component unmounts
    window.removeEventListener("resize", this.measureImage);
  }

  render() {
    const { classes } = this.props;
    const maps = this.props.maps;

    return (
      <div className={classes.root}>
        {/* BODY IMAGE */}
        <img
          src={maps[this.props.currentMapId].image}
          className={classes.image}
          alt={"Outline of body with acquisition locations mapped onto it."}
          ref={this.imageRef}
          useMap={"#CustomFaceMap_" + this.props.reviewStudyId}
        />

        <div
          className={classes.locationsContainer}
          style={{
            height: this.state.imgHeight,
            width: this.state.imgWidth,
          }}
          ref={this.locationsContainer}
        >
          <svg height={this.state.imgHeight} width={this.state.imgWidth}>
            {this.props.mapLocationIds.map((id) => {
              return (
                <SimpleMapRegion
                  key={id}
                  id={id}
                  imgWidth={this.state.imgWidth}
                  imgHeight={this.state.imgHeight}
                  currentMapId={this.props.currentMapId}
                  reviewStudyId={this.props.reviewStudyId}
                  setColorScaleValue={(colorValue) =>
                    this.props.setColorScaleValue(colorValue)
                  }
                  setSeriesVisibility={(id) =>
                    this.props.setSeriesVisibility(id)
                  }
                />
              );
            })}
          </svg>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const reviewStudy = state.availableParticipants.reviewStudies[ownProps.id];
  let swsMin = null;
  let swsMax = 0;

  Object.keys(reviewStudy.locations.byId).forEach((locationId) => {
    const sws = reviewStudy.locations.byId[locationId].shearWaveSpeed.value;
    if (sws > swsMax) {
      swsMax = sws;
    }
    if ((sws != null && sws < swsMin) || swsMin == null) {
      swsMin = sws;
    }
  });

  let mapLocationIds = reviewStudy.locations.allIds.filter((locationId) => {
    const location = reviewStudy.protocol.locations[locationId];
    //Only locations that have coordinated for the chosen bodymap AND are note removed from study
    if (location.maps[ownProps.bodyMapId] && !location.removed) {
      return true;
    }
    return false;
  });

  return {
    reviewStudyId: ownProps.id,
    mapLocationIds: mapLocationIds, // only subset of location ids that are in currently selected bodyMap
    currentMapId: ownProps.bodyMapId,
    maps: reviewStudy.protocol.maps,
    locations: reviewStudy.locations.byId,
    swsMin: swsMin,
    swsMax: swsMax,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(SimpleBodyMap));
